import { forwardRef } from "react";

/**
 * Off-screen export-ready card for "Share as Image".
 * Fixed dimensions so the downloaded PNG looks like a real wallpaper.
 */
export const ShareCard = forwardRef(({ verse, backgroundUrl }, ref) => {
  if (!verse) return null;
  return (
    <div
      ref={ref}
      data-testid="share-card"
      style={{
        position: "fixed",
        top: "-10000px",
        left: "-10000px",
        width: "1080px",
        height: "1920px",
        background: "#F5F3ED",
        overflow: "hidden",
      }}
    >
      {backgroundUrl && (
        <img
          src={backgroundUrl}
          alt=""
          crossOrigin="anonymous"
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: 0.5,
          }}
        />
      )}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "rgba(245,243,237,0.82)",
        }}
      />
      <div
        style={{
          position: "relative",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "120px 100px",
          textAlign: "center",
          color: "#2C2A28",
        }}
      >
        <p
          style={{
            fontFamily: "Fraunces, Georgia, serif",
            fontWeight: 300,
            fontSize: "76px",
            lineHeight: 1.22,
            letterSpacing: "-0.01em",
            margin: 0,
          }}
        >
          “{verse.text}”
        </p>
        <div
          style={{
            marginTop: "60px",
            display: "flex",
            alignItems: "center",
            gap: "24px",
          }}
        >
          <span style={{ height: 1, width: 64, background: "#96918A66" }} />
          <p
            style={{
              fontFamily: "Fraunces, Georgia, serif",
              fontStyle: "italic",
              fontSize: "38px",
              color: "#4A5D4E",
              margin: 0,
            }}
          >
            {verse.reference}
            <span
              style={{
                fontFamily: "Fraunces, 'Iowan Old Style', Georgia, serif",
                fontStyle: "normal",
                fontSize: "22px",
                color: "#96918A",
                letterSpacing: "0.2em",
                marginLeft: "16px",
              }}
            >
              {verse.translation}
            </span>
          </p>
          <span style={{ height: 1, width: 64, background: "#96918A66" }} />
        </div>
        <p
          style={{
            marginTop: "60px",
            fontFamily: "Manrope, sans-serif",
            fontSize: "30px",
            lineHeight: 1.55,
            color: "#6A6661",
            maxWidth: "780px",
          }}
        >
          {verse.explanation}
        </p>
        <div style={{ position: "absolute", bottom: "80px", left: 0, right: 0 }}>
          <p
            style={{
              fontFamily: "Manrope, sans-serif",
              fontSize: "20px",
              letterSpacing: "0.35em",
              textTransform: "uppercase",
              color: "#96918A",
              margin: 0,
              textAlign: "center",
            }}
          >
            Lifted Daily
          </p>
        </div>
      </div>
    </div>
  );
});
